import React, { useCallback, useEffect, useState } from 'react'
import { Storage } from 'utils/storage'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { AppLink } from 'components/Utility/AppLink/AppLink'
import styles from './Cookie.module.scss'

const COOKIE_ACCEPTED_KEY = 'cookieok'

export const Cookie: React.FC = () => {
  const [showCookie, setShowCookie] = useState(false)

  useEffect(() => {
    setShowCookie(!Storage.getItem(COOKIE_ACCEPTED_KEY))
  }, [])

  const accept = useCallback(() => {
    Storage.setItem(COOKIE_ACCEPTED_KEY, 1)
    setShowCookie(false)
  }, [])

  if (!showCookie) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.constrains}>
        <div className={styles.text}>
          Мы используем cookie-файлы для наилучшего представления нашего сайта. <br />
          Цели использования файлов cookie определены в <AppLink target={'_blank'} href={'/personal'}>Политике
          обработки персональных данных.</AppLink><br />
          Если вы согласны и дальше получать файлы cookie, пожалуйста, нажмите кнопку «Принять»
        </div>
        <AppButton shadowColor={'yellow'} className={styles.button} onClick={accept}>
          Принять
        </AppButton>
      </div>
    </div>
  )
}
